import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IShift } from 'src/app/modules/core/interfaces';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { IStatusByMachineTable } from 'src/app/modules/widget/interfaces/status-by-machine-table';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication';
import { DashboardWidgetBasicComponent } from '../../dashboard-widget-basic/dashboard-widget-basic.component';

@Component({
  selector: 'app-status-by-machine-table',
  templateUrl: './status-by-machine-table.component.html',
  styleUrls: ['./status-by-machine-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StatusByMachineTableComponent extends DashboardWidgetBasicComponent implements OnInit, OnDestroy {
  public displayTable: boolean;
  public displayMessage: boolean;
  public originalData: IStatusByMachineTable[];
  public subtitleWidget: string;

  constructor(
    public booleanBarService: BooleanStateService,
    public communication: CommunicationService,
    public parameterService: ParameterHandlerService,
    public cacheService: CacheService,
    public machineContext: MachineContextService,
    protected screenViewService: ScreenViewService,
    private langService: LanguageService,
    private datePipe: DatePresentationPipe,
  ) {
    super(booleanBarService, communication, parameterService, cacheService, machineContext, screenViewService);
    this.displayTable = false;
    this.displayMessage = false;
    this.initRequestParams();
  }

  /**
   * Init request params
   */
  protected initRequestParams(): void {
    this.params = {
      hasShift: true,
      hasCompany: true,
      hasDate: true,
      hasMachineType: false,
    };
  }

  /**
   * On init component
   */
  public ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Build widget view
   */
  public buildView(values: any): void {
    super.buildView(values);
    this.getData(values);
  }

  /**
   * Get data from API
   */
  private getData(statusMachineTable: IStatusByMachineTable[]): void {
    const machineType = this.parameterService.parameters.item('machine-context').value || 'no disponible';
    const date = this.parameterService.parameters.item('date').value;
    const shiftName = this.parameterService.parameters.item('shift').value as IShift;
    const user = this.parameterService.parameters.item('user-data').value;

    this.subtitleWidget = `${this.langService.message('company')}: ${user.company.name},
    ${this.langService.message('device')}: ${this.langService.message(machineType.name)},
    ${this.langService.message('date')}: ${this.datePipe.transform(date)},
    ${this.langService.message('shift_')}: ${shiftName.name}`;

    this.displayMessage = !statusMachineTable.length;
    this.originalData = [...statusMachineTable];
    this.displayTable = !!this.originalData.length;
  }

  /**
   * On destroy component
   */
  public onDestroy(): void {
    super.ngOnDestroy();
  }
}
